<div
  class="row fixed-bottom-bar bg-basic pt-2 pt-md-2 ps-md-2 pe-md-2 pt-lg-3 pt-xl-4 ps-xl-4 pe-xl-4 ps-xl-3 pe-xl-3"
  >
  <ng-template #certificatesNavItem>
    <div class="col col-md-12">
      <div
        class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
        [routerLink]="certificatesRoute"
        routerLinkActive="active"
        [routerLinkActiveOptions]="exactLinkActiveOptions"
        >
        <svg class="menu-icon menu-icon-md" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M4 3C2.89 3 2 3.89 2 5V15C2 15.5304 2.21071 16.0391 2.58579 16.4142C2.96086 16.7893 3.46957 17 4 17H12V22L15 19L18 22V17H20C20.5304 17 21.0391 16.7893 21.4142 16.4142C21.7893 16.0391 22 15.5304 22 15V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3H4ZM12 5L15 7L18 5V8.5L21 10L18 11.5V15L15 13L12 15V11.5L9 10L12 8.5V5ZM4 5H9V7H4V5ZM4 9H7V11H4V9ZM4 13H9V15H4V13Z"/>
        </svg>
        <br />
        <span class="d-none d-md-block">{{ "navbar.certificates" | translate }}</span>
        <span class="d-block d-md-none">{{ "navbar.certificatesMobile" | translate }}</span>
      </div>
    </div>
  </ng-template>

  <div class="col col-md-12">
    <div
      class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
      [routerLink]="homeRoute"
      routerLinkActive="active"
      >
      <svg class="menu-icon menu-icon-md" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0.5L0 6.5V18.5H5V11.5H11V18.5H16V6.5L8 0.5Z"/>
      </svg>
      <br />
      <span>{{"navbar.home" | translate}}</span>
    </div>
  </div>

  @if (isDesktop) {
    @if (domainService.featureFlags()["inductionCourses"]) {
      <div class="col col-md-12">
        <div
          class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
          [routerLink]="inductionRoute"
          routerLinkActive="active"
          [routerLinkActiveOptions]="exactLinkActiveOptions"
          >
          <svg
            class="menu-icon menu-icon-md"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            [innerHTML]="inductionNavIconSvg | sanitizeHtml"
          ></svg>
          <br />
          <span>{{ "navbar.induction" | translate }}</span>
        </div>
      </div>
    }
    <ng-container *ngTemplateOutlet="certificatesNavItem" />
    <div class="col col-md-12">
      <div
        class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
        routerLink="/help-forum"
        routerLinkActive="active"
        >
        <svg class="menu-icon menu-icon-md" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.99 2C19.99 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H16L20 20L19.99 2ZM15 12H5C4.45 12 4 11.55 4 11C4 10.45 4.45 10 5 10H15C15.55 10 16 10.45 16 11C16 11.55 15.55 12 15 12ZM15 9H5C4.45 9 4 8.55 4 8C4 7.45 4.45 7 5 7H15C15.55 7 16 7.45 16 8C16 8.55 15.55 9 15 9ZM15 6H5C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4H15C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6Z"/>
        </svg>
        <br />
        <span>{{"navbar.helpForum" | translate}}</span>
      </div>
    </div>
  }

  @if (!isDesktop) {
    <div class="col col-md-12">
      <div
        class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
        routerLink="/notifications"
        routerLinkActive="active"
        >
        <span class="menu-icon-wrap">
          <svg class="menu-icon menu-icon-md" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9993 25.666C15.2827 25.666 16.3327 24.616 16.3327 23.3327H11.666C11.666 24.616 12.7043 25.666 13.9993 25.666ZM20.9993 18.666V12.8327C20.9993 9.25102 19.086 6.25268 15.7493 5.45935V4.66602C15.7493 3.69768 14.9677 2.91602 13.9993 2.91602C13.031 2.91602 12.2493 3.69768 12.2493 4.66602V5.45935C8.90099 6.25268 6.99933 9.23935 6.99933 12.8327V18.666L5.49433 20.171C4.75933 20.906 5.27266 22.166 6.31099 22.166H21.676C22.7143 22.166 23.2393 20.906 22.5043 20.171L20.9993 18.666Z"/>
          </svg>
          <svg
            width="8"
            height="8"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="navbar-notification-dot"
            [class.inv]="!notificationData.hasUnread()"
            aria-hidden="true"
            >
            <circle cx="3" cy="3" r="3" fill="#FF014D" />
          </svg>
        </span>
        <br />
        <span>{{"navbar.notifications" | translate}}</span>
      </div>
    </div>

    <div class="col col-md-12">
      <div
        class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
        routerLink="/statistics"
        routerLinkActive="active"
        >
        <svg class="menu-icon menu-icon-md" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.46732 5.73398H2.70065C3.59898 5.73398 4.33398 6.46898 4.33398 7.36732V15.534C4.33398 16.4323 3.59898 17.1673 2.70065 17.1673H2.46732C1.56898 17.1673 0.833984 16.4323 0.833984 15.534V7.36732C0.833984 6.46898 1.56898 5.73398 2.46732 5.73398ZM9.00065 0.833984C9.89898 0.833984 10.634 1.56898 10.634 2.46732V15.534C10.634 16.4323 9.89898 17.1673 9.00065 17.1673C8.10232 17.1673 7.36732 16.4323 7.36732 15.534V2.46732C7.36732 1.56898 8.10232 0.833984 9.00065 0.833984ZM15.534 10.1673C16.4323 10.1673 17.1673 10.9023 17.1673 11.8007V15.534C17.1673 16.4323 16.4323 17.1673 15.534 17.1673C14.6357 17.1673 13.9007 16.4323 13.9007 15.534V11.8007C13.9007 10.9023 14.6357 10.1673 15.534 10.1673Z"/>
        </svg>
        <br />
        <span>{{"navbar.statistics" | translate}}</span>
      </div>
    </div>
  }

  <div class="col col-md-12">
    <div
      class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
      routerLink="/press-releases"
      routerLinkActive="active"
      >
      <svg class="menu-icon menu-icon-md" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM13 14H6V12H13V14ZM18 10H6V8H18V10ZM18 6H6V4H18V6Z"/>
      </svg>
      <br />
      <span class="d-none d-md-block">{{"navbar.pressReleases" | translate}}</span>
      <span class="d-block d-md-none">{{"navbar.pressReleasesMobile" | translate}}</span>
    </div>
  </div>

  @if (isDesktop) {
    <div class="col col-md-12">
      <div
        class="menu-item d-md-flex align-items-md-center text-center text-left-md py-md-3 ps-md-3"
        routerLink="/statistics"
        routerLinkActive="active"
        >
        <svg class="menu-icon menu-icon-md" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.46732 5.73398H2.70065C3.59898 5.73398 4.33398 6.46898 4.33398 7.36732V15.534C4.33398 16.4323 3.59898 17.1673 2.70065 17.1673H2.46732C1.56898 17.1673 0.833984 16.4323 0.833984 15.534V7.36732C0.833984 6.46898 1.56898 5.73398 2.46732 5.73398ZM9.00065 0.833984C9.89898 0.833984 10.634 1.56898 10.634 2.46732V15.534C10.634 16.4323 9.89898 17.1673 9.00065 17.1673C8.10232 17.1673 7.36732 16.4323 7.36732 15.534V2.46732C7.36732 1.56898 8.10232 0.833984 9.00065 0.833984ZM15.534 10.1673C16.4323 10.1673 17.1673 10.9023 17.1673 11.8007V15.534C17.1673 16.4323 16.4323 17.1673 15.534 17.1673C14.6357 17.1673 13.9007 16.4323 13.9007 15.534V11.8007C13.9007 10.9023 14.6357 10.1673 15.534 10.1673Z"/>
        </svg>
        <br />
        <span>{{"navbar.statistics" | translate}}</span>
      </div>
    </div>
  }

  @if (!isDesktop) {
    <ng-container *ngTemplateOutlet="certificatesNavItem" />
  }

  @if (isDesktop && pwaInstall.canOffer()) {
    <footer class="col col-md-12 navbar-footer py-3">
      <app-install-app-button fullWidth />
    </footer>
  }
</div>
